/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GMN
 */
export interface GMN {
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  readonly uuid?: string;
  /**
   * Alleen beschikbaar voor de eigenaar van de put.
   * @type {string}
   * @memberof GMN
   */
  internalId: string | null;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  deliveryAccountableParty: string | null;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  qualityRegime: string | null;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  name: string | null;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  deliveryContext: string | null;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  monitoringPurpose: string | null;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  groundwaterAspect: string | null;
  /**
   *
   * @type {Date}
   * @memberof GMN
   */
  startDateMonitoring: Date | null;
  /**
   *
   * @type {Date}
   * @memberof GMN
   */
  endDateMonitoring: Date | null;
  /**
   *
   * @type {Date}
   * @memberof GMN
   */
  objectRegistrationTime: Date | null;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  registrationStatus: string | null;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  color: string | null;
  /**
   *
   * @type {Date}
   * @memberof GMN
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GMN
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof GMN
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GMN interface.
 */
export function instanceOfGMN(value: object): value is GMN {
  if (
    (!("internalId" in (value as Record<string, any>)) &&
      !("internal_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["internalId"] === undefined &&
      (value as Record<string, any>)["internal_id"] === undefined)
  )
    return false;
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("deliveryAccountableParty" in (value as Record<string, any>)) &&
      !("delivery_accountable_party" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryAccountableParty"] === undefined &&
      (value as Record<string, any>)["delivery_accountable_party"] === undefined)
  )
    return false;
  if (
    (!("qualityRegime" in (value as Record<string, any>)) &&
      !("quality_regime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["qualityRegime"] === undefined &&
      (value as Record<string, any>)["quality_regime"] === undefined)
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    (!("deliveryContext" in (value as Record<string, any>)) &&
      !("delivery_context" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryContext"] === undefined &&
      (value as Record<string, any>)["delivery_context"] === undefined)
  )
    return false;
  if (
    (!("monitoringPurpose" in (value as Record<string, any>)) &&
      !("monitoring_purpose" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["monitoringPurpose"] === undefined &&
      (value as Record<string, any>)["monitoring_purpose"] === undefined)
  )
    return false;
  if (
    (!("groundwaterAspect" in (value as Record<string, any>)) &&
      !("groundwater_aspect" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["groundwaterAspect"] === undefined &&
      (value as Record<string, any>)["groundwater_aspect"] === undefined)
  )
    return false;
  if (
    (!("startDateMonitoring" in (value as Record<string, any>)) &&
      !("start_date_monitoring" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startDateMonitoring"] === undefined &&
      (value as Record<string, any>)["start_date_monitoring"] === undefined)
  )
    return false;
  if (
    (!("endDateMonitoring" in (value as Record<string, any>)) &&
      !("end_date_monitoring" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endDateMonitoring"] === undefined &&
      (value as Record<string, any>)["end_date_monitoring"] === undefined)
  )
    return false;
  if (
    (!("objectRegistrationTime" in (value as Record<string, any>)) &&
      !("object_registration_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["objectRegistrationTime"] === undefined &&
      (value as Record<string, any>)["object_registration_time"] === undefined)
  )
    return false;
  if (
    (!("registrationStatus" in (value as Record<string, any>)) &&
      !("registration_status" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["registrationStatus"] === undefined &&
      (value as Record<string, any>)["registration_status"] === undefined)
  )
    return false;
  if (!("color" in value) || value["color"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GMNFromJSON(json: any): GMN {
  return GMNFromJSONTyped(json, false);
}

export function GMNFromJSONTyped(json: any, ignoreDiscriminator: boolean): GMN {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    internalId: json["internal_id"],
    broId: json["bro_id"],
    deliveryAccountableParty: json["delivery_accountable_party"],
    qualityRegime: json["quality_regime"],
    name: json["name"],
    deliveryContext: json["delivery_context"],
    monitoringPurpose: json["monitoring_purpose"],
    groundwaterAspect: json["groundwater_aspect"],
    startDateMonitoring:
      json["start_date_monitoring"] == null ? null : new Date(json["start_date_monitoring"]),
    endDateMonitoring:
      json["end_date_monitoring"] == null ? null : new Date(json["end_date_monitoring"]),
    objectRegistrationTime:
      json["object_registration_time"] == null ? null : new Date(json["object_registration_time"]),
    registrationStatus: json["registration_status"],
    color: json["color"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    dataOwner: json["data_owner"],
  };
}

export function GMNToJSON(json: any): GMN {
  return GMNToJSONTyped(json, false);
}

export function GMNToJSONTyped(
  value?: Omit<GMN, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    internal_id: value["internalId"],
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    quality_regime: value["qualityRegime"],
    name: value["name"],
    delivery_context: value["deliveryContext"],
    monitoring_purpose: value["monitoringPurpose"],
    groundwater_aspect: value["groundwaterAspect"],
    start_date_monitoring:
      value["startDateMonitoring"] == null
        ? value["startDateMonitoring"]
        : value["startDateMonitoring"].toISOString().substring(0, 10),
    end_date_monitoring:
      value["endDateMonitoring"] == null
        ? value["endDateMonitoring"]
        : value["endDateMonitoring"].toISOString().substring(0, 10),
    object_registration_time:
      value["objectRegistrationTime"] == null
        ? value["objectRegistrationTime"]
        : value["objectRegistrationTime"].toISOString(),
    registration_status: value["registrationStatus"],
    color: value["color"],
    data_owner: value["dataOwner"],
  };
}
